const getFixSelectionBugFunction =
  (classType, checkType) => (data, formioRef) => {
    if (Array.isArray(data) || typeof data !== 'object') return;

    Array.from(
      formioRef?.current?.getElementsByClassName?.(classType) ?? []
    ).forEach((element) => {
      const key = element.getAttribute('data-key');
      const value = isNaN(data[key]) ? data[key] : data[key]?.toString();

      if (Boolean(value) || value === '') {
        Array.from(
          element?.getElementsByClassName?.('form-check') ?? []
        ).forEach((option) => {
          const input = option?.getElementsByTagName?.('input')?.[0];
          checkType(value, input?.getAttribute?.('value'))
            ? option?.classList?.add('selected')
            : option?.classList?.remove('selected');
        });
      }
    });
  };

export const fixRadioSelectionBug = getFixSelectionBugFunction(
  'formio-component-radio',
  (value, attributeValue) => value === attributeValue
);
export const fixCheckboxSelectionBug = getFixSelectionBugFunction(
  'formio-component-selectboxes',
  (value, attributeValue) => Boolean(value[attributeValue])
);
